import { navLinks } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-foreground-950 font-heading text-lg font-bold">
                黑
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">
                黑料网5
              </span>
            </div>
            <p className="mt-5 font-body text-sm leading-relaxed text-background-300 max-w-md">
              把分站特色、主站与分站的区别、以及各独立版块的玩法差异，集中摆在首页。先看结构，再决定追哪些方向，浏览起来省一半来回翻的功夫。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              <span className="px-3 py-1.5 rounded-full bg-secondary-800 text-secondary-100 font-label text-xs">
                分站特色
              </span>
              <span className="px-3 py-1.5 rounded-full bg-secondary-800 text-secondary-100 font-label text-xs">
                区别对照
              </span>
              <span className="px-3 py-1.5 rounded-full bg-secondary-800 text-secondary-100 font-label text-xs">
                专属区块
              </span>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              页面导航
            </h4>
            <ul className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="font-label text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              先看什么
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-2.5 font-label text-sm text-background-300">
                <span className="w-5 h-5 mt-0.5 shrink-0 flex items-center justify-center text-primary-400">
                  <i className="ri-check-line text-[16px]"></i>
                </span>
                第一次来先看「区别对比」，了解主站与分站的不同。
              </li>
              <li className="flex items-start gap-2.5 font-label text-sm text-background-300">
                <span className="w-5 h-5 mt-0.5 shrink-0 flex items-center justify-center text-primary-400">
                  <i className="ri-check-line text-[16px]"></i>
                </span>
                有明确方向就直接进对应的独立版块。
              </li>
              <li className="flex items-start gap-2.5 font-label text-sm text-background-300">
                <span className="w-5 h-5 mt-0.5 shrink-0 flex items-center justify-center text-primary-400">
                  <i className="ri-check-line text-[16px]"></i>
                </span>
                想顺着话题追，就从标签墙进去。
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="font-label text-xs text-background-400">
            © 2026 黑料网5 · 分站特色与区别导览页
          </p>
          <p className="font-label text-xs text-background-400">
            本站为静态展示页面，按钮与搜索框仅作交互演示
          </p>
        </div>
      </div>
    </footer>
  );
}